<div class="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center p-8">
  <div>
    <h1 class="text-4xl lg:text-5xl font-bold mb-6 text-primary">Керуйте своїм магазином із Sokil CRM</h1>
    <p class="text-lg text-muted-color mb-6">Оптимізуйте свій склад, замовлення та відносини з клієнтами за допомогою
      нашої потужної та інтуїтивно зрозумілої платформи.</p>
  </div>
  <div class="text-center mt-8 lg:mt-0">
    <i class="pi pi-chart-line text-primary opacity-75" style="font-size: 10rem;"></i>
  </div>
</div>
